jQuery(function($){
    $('.tel-btn').attr('href','tel:1300 054 055');
    $('.tel-btn').attr('title','tel:1300 054 055');
    $('.tel-btn').find('.telphone').text('- 1300 054 055');

    /*---------Mega menu----------*/
    $('.mega-menu').each(function(){
        var submenu = $(this).data('dropdown');
        $('.submenu--'+submenu).remove();
    });
    $('.mainMenu > .dropdown').on('mouseenter touchstart', function(){
        var elemSelector =$(this).find('.mainMenu__link').data('dropdown-rel');
        $('.dropdown_container').not('[data-dropdown="'+elemSelector+'"]').hide();
        $('[data-dropdown="'+elemSelector+'"]').show();
    });

    $('.dropdown_container').on('mouseleave', function(){
        $('.dropdown_container').hide();
    });

    $('.announcementBar').on('mouseenter', function(){
        $('.dropdown_container').hide();
    });


    /*-----Maintaining banner below header------*/
    $('.shapesOverflow').css({'margin-top': ($('.sticky_header').height())+'px'});
    $('.mega-menu .menu').css({'top': $('.sticky_header').height()+'px'});
    $(window).resize(function(){
        $('.shapesOverflow').css({'margin-top': ($('.sticky_header').height())+'px'});
        $('.mega-menu .menu').css({'top': $('.sticky_header').height()+'px'});
    });

    $('.js-close-announcement').on('click', function(){
        $('.mega-menu .menu').css({'top': $('.sticky_header').height()+'px'});
        $('.shapesOverflow').css({'margin-top': ($('.sticky_header').height())+'px'});
    });

    /*-------Mega menu mobile--------*/
    // $('.mega-menu-container .mobile-mega-menu').each(function(index){
    //     //$('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
    //     $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
    //     $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
    //     $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
    //     $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
    //       $(this).removeClass('hidden');
    //       if (!$(this).hasClass('mobile-mega-menu')) {
    //         //$(this).remove();
    //       }
    //     });

    //   });

    $('.mega-menu-container .mobile-mega-menu').each(function(index){
        console.log("HERERERER")
        //$('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find('span').remove();
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr('data-no-instant', 'true');
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass('mobile-mega-menu-parent sublink');
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this);
        $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(index){
            $(this).removeClass('hidden');
            if (!$(this).hasClass('mobile-mega-menu')) {
                $(this).remove(); //readded by m3 29/03/21 - need to add custom dropdown, toggle selects first ul available
            }
        });

    });

    $('.whyus .textColumn__blocks').append('<div class="showall"><span>show all the details +</span></div>');
    $('.showall span').click(function() {
        if($(this).hasClass('expand')) {
            $(this).removeClass('expand');
            $('.whyus .textColumn__text').slideUp(200);
            $('.whyus-product-content p').slideUp(200);
            $(this).text('show all the details +');
        } else {
            $(this).addClass('expand');
            $('.whyus .textColumn__text').slideDown(200);
            $('.whyus-product-content p').slideDown(200);
            $(this).text('hide all the details +');
        }
    });
    $('.why-mm-chairs-container').slick({
        slidesToShow: 3,
        autoplay: true,
        arrow: true,
        responsive: [
            {
            breakpoint: 991,
            settings: {
                slidesToShow: 1
            }
            }
        ]
    });

    /*------ Text column accordian -------*/
    /*
    $( '.content-trigger' ).click(function() {
      $(this).next().slideToggle(200);
      return false;
    });
    */

    $('.main-box .image-box .box-one').each(function(){
        $(this).insertAfter($(this).next());
    });

    $(document).ready(function (){
        $("#zipmoney").click(function (){
            $('html, body').animate({
                scrollTop: $("#shopify-zip-product-widget").offset().top
            }, 1000);
        });

        $("#certegy").click(function (){
            $('html, body').animate({
                scrollTop: $("#certegy-write-up").offset().top
            }, 1000);
        });

        $(".teams__more-link").click(function (){
            $('html, body').animate({
                scrollTop: $("#team-member").offset().top - $(".sticky_header").innerHeight()
            }, 1000);
        });

        $('.our-team .logoBar__content').wrapInner('<div class="owl-carousel"></div>');
        $('.our-team-product').wrapInner('<div class="owl-carousel"></div>');

        $('.our-team .logoBar__content .owl-carousel').owlCarousel({
            autoplay: true,
            slideTransition: 'linear',
            autoplayTimeout : 4000,
            autoplayHoverPause : false,
            autoplaySpeed : 4000,
            dots: false,
            loop: true,
            margin: 20,
            nav: false,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 4
                },
                1000: {
                    items: 5
                }
            }
        });

        // Testimonials page video slider
        $('.video-carousel .media-wrapper.owl-carousel').owlCarousel({
            items:1,
            // merge:true,
            stagePadding: 50,
            margin: 10,
            loop:true,
            lazyload:true,
            center: false,
            dots: false,
            nav: true,
            responsive: {
                600: {
                    items: 2
                }
            }
        });

        // Testimonials page video slider
        $('.video-carousel .media-wrapper-collection.owl-carousel').owlCarousel({
            items:1,
            margin: 10,
            loop:true,
            lazyload:true,
            center: false,
            dots: false,
            nav: true,
            responsive: {
                600: {
                    items: 3
                }
            }
        });

        $('.our-team-product .owl-carousel').owlCarousel({
            autoplay: true,
            slideTransition: 'linear',
            autoplayTimeout : 4000,
            autoplayHoverPause : false,
            autoplaySpeed : 4000,
            dots: false,
            loop: true,
            margin: 30,
            nav: false,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 4
                },
                1000: {
                    items: 5
                }
            }
        });

        $('.accordion-technology .accordion__header').click(function(){
            var activeimg = $(this).attr('id');
            $('.img-technology').hide();
            $('.'+activeimg).show();
        });

        if($('.specifications-fit').length) {
            $('.specifications-fit').appendTo('.shopify-product-form');
        }

        countDown();
        var countdown = setInterval(countDown, 1000);

        function countDown()
        {
            day_today=moment().format("DD");
            month_today=moment().format("MM");
            year_today=moment().format("YYYY");

            if(day_today % 3 ==0)
                var future = moment( year_today+'-'+month_today+'-'+day_today+'T23:59:59.000Z');
            else{
                //find next day mod by 3
                if(day_today==31) day_today=1;
                if(month_today==02)
                {
                    if((day_today==28) || (day_today==29))
                        day_today=1;
                }
                day_future=day_today;
                while (day_future % 3!=0)            {

                    day_future++;
                }

                diff=day_future-day_today;

                future_date=moment().add(diff,'days');
                day_future=moment().format("DD");
                month_future=moment().format("MM");
                year_future=moment().format("YYYY");

                //console.log(day_today);

                var future = moment( year_future+'-'+month_future+'-'+day_future+'T23:59:59.000Z');
            }

            var now = moment();

            var _widget = document.getElementById( 'timer-widget-' + '212' );

            if(!_widget) return

            var days_elem = 	_widget.getElementsByClassName( 'days' )[0].getElementsByTagName( 'span' )[0];
            var hours_elem = 	_widget.getElementsByClassName( 'hours' )[0].getElementsByTagName( 'span' )[0];
            var minutes_elem = 	_widget.getElementsByClassName( 'minutes' )[0].getElementsByTagName( 'span' )[0];
            var seconds_elem = 	_widget.getElementsByClassName( 'seconds' )[0].getElementsByTagName( 'span' )[0];
            var delta = 		Math.abs( future - now ) / 1000;
            var days = 0;
            var hours = 0;
            var minutes = 0;
            var seconds = 0;

            if( future - now <= 0 )
            {
                clearInterval(countdown);
            }
            else
            {
                days = Math.floor( delta / 86400 );
                delta -= days * 86400;

                hours = Math.floor( delta / 3600 ) % 24;
                delta -= hours * 3600;

                minutes = Math.floor( delta / 60 ) % 60;
                delta -= minutes * 60;

                seconds = Math.floor( delta % 60 );
            }
            days_elem.innerHTML = 		formatDigits( days, 2 );
            hours_elem.innerHTML = 		formatDigits( hours, 2 );
            minutes_elem.innerHTML = 	formatDigits( minutes, 2 );
            seconds_elem.innerHTML = 	formatDigits( seconds, 2 );

            function formatDigits( value, digits_number )
            {
                if ( value.toString().length < digits_number )
                {
                    return ( new Array( digits_number - value.toString().length + 1 ).join( '0' ) ) + value;
                }
                else
                {
                    return value;
                }
            }
        }
    });
//google tag tracking
    $("#contact_form .submit").on('click', function() {
        console.log('contact clicked');
        dataLayer.push({'event': 'button-contact-us-clicked'});
    });
//end of google tag tracking
    $('table#google_reviews tr:first').addClass('active');

    $('.hellobar-phonecall').click(function(){
        ga('send', 'event', 'Phone Number', 'Clicked', 'Hellobar Phone Call', 1);
    });


    $('a.reviews_load_more').on('click', function(e) {
        e.preventDefault();
        var $rows = $('table#google_reviews tr');
        var lastActiveIndex = $rows.filter('.active:last').index();
        $rows.filter(':lt(' + (lastActiveIndex + 2) + ')').addClass('active');
    });

    $('.tooltipstered').tooltipster({   		maxWidth: 400, theme: 'tooltipster-shadow', animationDuration:'0'});
    $('map').imageMapResize();
    $('area.tooltipstered').click(function(){ return false; });

    $('#moneymarket').on('click', function(e) {
        e.preventDefault();
        var position = $("#ourmoneymarket").offset().top;
        $('html, body').animate({ scrollTop: position }, 2000);
    });

    $('.__pf a[href^="#"]').each(function(){
        $(this).click(function(e){
            e.preventDefault();
            var target = $(this).attr('href');
            var position = $(target).offset().top - $('.sticky_header').height();
            if(position) {
                $('html, body').animate({
                    scrollTop: position }, 2000);
            }
        });
    });

    $('#c-submit-button').click(function(){
        var position = $('.cognito').offset().top - $('.sticky_header').height();
        if(position) {
            $('html, body').animate({
                scrollTop: position }, 400);
        }
    });

    $(document).on('afterSubmit.cognito', function(e, data) {
        var position = $('.cognito').offset().top - $('.sticky_header').height();
        if(position) {
            $('html, body').animate({
                scrollTop: position }, 400);
        }
    });

    function postsCarousel() {
        var checkWidth = $(window).width();
        var owlPost = $(".whyus-product-content");
        if (checkWidth > 481) {
            if(typeof owlPost.data('owl.carousel') != 'undefined'){
                owlPost.data('owl.carousel').destroy();
            }
            owlPost.removeClass('owl-carousel');
        } else if (checkWidth < 480) {
            owlPost.addClass('owl-carousel');
            owlPost.owlCarousel({
                items : 1,
                dots: true,
                margin: 0,
                nav: false
            });
        }
    }

    postsCarousel();
    $(window).resize(postsCarousel);
});
/*Hide the slider while loading*/
const checkSliderState = setInterval(() => {
    const slider = document.querySelector(".header-scroll__slider.am-slider.sixteen.columns.slick-initialized.slick-slider");
    const sliderContainer = document.querySelector(".announcementBar");
    if (slider !== null) {
        sliderContainer.style.display = "block";
        clearInterval(checkSliderState);
    }
}, 100);


/* Adjust the content margin if the announcementBar change height*/
const adjustContentMargin = setInterval(() => {
    $('.shapesOverflow').css({'margin-top': ($('.sticky_header').height())+'px'});
    $('.mega-menu .menu').css({'top': $('.sticky_header').height()+'px'});
}, 10);

/*remove 60px padding bottom*/
$( document ).ready(function() {
    console.log( "ready!" );
    $('html').css("padding-bottom", "0");
});

/*Remove link to the first 2 links*/
$('li[data-mobile-dropdown-rel="massage-chairs"] > a').removeAttr('href');
$('li[data-mobile-dropdown-rel="massagers"] > a').removeAttr('href');


$('a[data-dropdown-rel="massage-chairs"]').removeAttr('href');
$('a[data-dropdown-rel="massagers"]').removeAttr('href');


$(".reason").on('click', function () {
    if ($(this).children(".reason-content").hasClass('open')) {
        $(this).children(".reason-content").removeClass("open");
        $(this).children("img").attr('src', "//cdn.shopify.com/s/files/1/0053/3993/8880/t/140/assets/up-blue.png?v=43379131149317944881683832761");
    } else {
        $(this).children(".reason-content").addClass("open");
        $(this).children("img").attr('src', "//cdn.shopify.com/s/files/1/0053/3993/8880/t/140/assets/down-blue.png?v=109245541145358331651683832775");
    }

});

$("#best-3-chairs .read-more").on('click', function () {
    if ($(this).text() === "Read more") {
        $(this).text("Read less");
        $(this).parent().children(".massage-chair-desc:nth-child(3)").css("display", "block");
    } else {
        $(this).text("Read more");
        $(this).parent().children(".massage-chair-desc:nth-child(3)").css("display", "none");
    }
});

$("#founder-note .read-more").on('click', function () {
    if ($(this).text() === "Read more") {
        $(this).text("Read less");
        $(this).parent().children("p.founder-message2").css("display", "block");
    } else {
        $(this).text("Read more");
        $(this).parent().children("p.founder-message2").css("display", "none");
    }
});

$("#sixteen-years-banner .read-more").on('click', function () {
    if ($(this).text() === "Read more") {
        $(this).text("Read less");
        $(this).parent().addClass("open");
    } else {
        $(this).text("Read more");
        $(this).parent().removeClass("open");
    }
});



    function labnolIframe(div) {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + div.dataset.id + '?autoplay=1');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '1');
        iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
        div.parentNode.replaceChild(iframe, div);
    }

    function initYouTubeVideos() {
        var playerElements = document.querySelectorAll('.youtube-player');
        for (var n = 0; n < playerElements.length; n++) {
            var videoId = playerElements[n].dataset.id;
            var div = document.createElement('div');
            div.setAttribute('data-id', videoId);
            var thumbNode = document.createElement('img');
            thumbNode.src = '//i.ytimg.com/vi/ID/hqdefault.jpg'.replace('ID', videoId);
            div.appendChild(thumbNode);
            var playButton = document.createElement('div');
            playButton.setAttribute('class', 'play');
            div.appendChild(playButton);
            div.onclick = function () {
                labnolIframe(this);
            };
            playerElements[n].appendChild(div);
        }
    }

    document.addEventListener('DOMContentLoaded', initYouTubeVideos);


    $(document).ready(function () {
        const checkSliderReady = setInterval(function () {
            if ($(".reviews-slider.slick-initialized").length > 0) {
                $(".videos-slider-container").addClass("active");
                clearInterval(checkSliderReady);
            }
        }, 100);
        let reviewSliderEl = document.querySelector(".reviews.slick-slide");
        const checkReviewSlider = setInterval(function () {
            reviewSliderEl = document.querySelector(".reviews.slick-slide")
            if (reviewSliderEl) {
                $('.review-message').each(function () {
                    var $element = $(this);
                    if ($element.height() > 80) {
                        $element.addClass('word-limit');
                        $element.after(`<span class="see-more">See more</span>`)
                    }
                });
                $("#client-reviews span.see-more").on('click', function () {
                    if ($(this).text() === "See more") {
                        $(this).text("See less");
                        $(this).parent().children('.review-message').removeClass("word-limit");
                    } else {
                        $(this).text("See more");
                        $(this).parent().children('.review-message').addClass("word-limit");
                    }

                });
                $("section#client-reviews").addClass("loaded");
                clearInterval(checkReviewSlider);
            }
        }, 100);

        $(".video-content img, .video-content svg").on('click', function () {
            $(this).parent().children('img').css('display', 'none');
            $(this).parent().children('svg').css('display', "none");
            $(this).parent().children('video').css('display', "block");
            $(this).parent().children('video').get(0).play();
        })
    });



var referenceHeight = $('.reviews-slider-container').height();
referenceHeight -= 104;


$("#client-reviews .nav-tab").on('click', function () {
    if ($(this).hasClass("review-product")) {
        $('#client-reviews .nav-tab').removeClass("active");
        $(this).addClass("active");
        $('.reviews-slider-container').addClass("active");
        $('.google-slider-container').removeClass("active");
        $('.videos-slider-container').removeClass("active");
        var referenceHeight = $('.reviews-slider').height();
        $('.reviews-container').height(referenceHeight);
        
    } else if ($(this).hasClass("review-google")) {
        $('#client-reviews .nav-tab').removeClass("active");
        $(this).addClass("active");
        $('.reviews-slider-container').removeClass("active");
        $('.google-slider-container').addClass("active");
        $('.videos-slider-container').removeClass("active");
        var referenceHeight = $('.google-slider').height();
        $('.reviews-container').height(referenceHeight);
        
    } else {
        $('#client-reviews .nav-tab').removeClass("active");
        $(this).addClass("active");
        $('.reviews-slider-container').removeClass("active");
        $('.google-slider-container').removeClass("active");
        $('.videos-slider-container').addClass("active");
        var referenceHeight = $('.video-masonry__contents').height();
        $('.reviews-container').height(referenceHeight);
        
    }
});

setInterval(function () {
    if ($("section#client-reviews.loaded").length > 0){
        if ($("#client-reviews .nav-tab.review-product").hasClass("active")) {
            referenceHeight = $('.reviews-slider').height();
            $('.reviews-container').height(referenceHeight);
        } else if ($("#client-reviews .nav-tab.review-google").hasClass("active")) {
            referenceHeight = $('.google-slider').height();
            $('.reviews-container').height(referenceHeight);
        } else {
            referenceHeight = $('.video-masonry__contents').height();
            $('.reviews-container').height(referenceHeight);
        }
    }
}, 100);
